import React from 'react';

import { VpPluginSwitchSection } from './VpPluginSwitchSection';
import { VpPluginTextDescriptionInputs } from '../..';

export const VpPluginDescriptionSection = () => {
  return (
    <VpPluginSwitchSection name="showDescription" label="DESCRIPTION">
      <VpPluginTextDescriptionInputs />
    </VpPluginSwitchSection>
  );
};

export default VpPluginDescriptionSection;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpPluginDetailsForm/VpPluginDescriptionSection.jsx